import { makeStyles, useTheme } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  listRoot: {
    width: '100%',
    maxWidth: 250,
    backgroundColor: theme.sideBar.backgroundColor
  },
  nested: {
    paddingLeft: `${theme.spacing(4)}px !important`,
  },
  item: {
    minWidth: `${theme.spacing(4)}px !important`,
    color: 'inherit !important'
  },
  divider: {
    marginTop: `${theme.spacing(1.5)}px !important`,
    marginBottom: `${theme.spacing(1.5)}px !important`
  },
  root: {
    zIndex: 1000,
    position: 'fixed',
    left: 250,
    width: 0,
    height: '100%', //'calc(100% - 116px)',
    marginLeft: -250,
    overflowY: 'auto',
    overflowX: 'hidden',
    background: theme.sideBar.backgroundColor,
    transition: 'all 0.25s ease',
    textTransform: 'uppercase',
    marginTop: 0,
    '& .sidebar-nav': {
      marginTop: 160
    }
  },
  a: {
    display: 'block',
    textDecoration: 'none',
    color: theme.sideBar.normal,
    '& span': {
      fontSize: '0.95rem'
    },
    '&.active': {
      color: theme.sideBar.active,
      backgroundColor: theme.sideBar.hoverBackground
    },
    '&.active:hover': {
      color: theme.sideBar.activeHoverColor
    },
    '&:hover': {
      textDecoration: 'none',
      color: theme.sideBar.hoverColor,
      background: theme.sideBar.hoverBackground
    }
  },
  img: {
    width: 72,
    height: 72,
    margin: 20,
    // borderRadius: 7
  }
}))

export {
  useStyles,
  useTheme
}
